import React, { useState } from 'react';
import axios from 'axios';
import './SellerForm.css'; // Import CSS file for styling
import { useParams, useNavigate } from 'react-router-dom';

function SellerForm() {
  const { pk } = useParams(); // Ensure you call useParams() as a function
  const navigate = useNavigate(); // Hook for navigation

  const [activeCategory, setActiveCategory] = useState('GST Details');
  const [formData, setFormData] = useState({
    'GST Details': { gst_number: '' },
    'Pickup Details': { pickup_address: '', store_name: '' },
    'Bank Details': { bank_name: '', account_no: '', ifsc_code: '' },
    'Supplier Address': { street: '', city: '', state: '', country: '', zipcode: '' }
  });

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  const handleInputChange = (category, field, value) => {
    setFormData({
      ...formData,
      [category]: {
        ...formData[category],
        [field]: value
      }
    });
  };

  const handleNextClick = (category, nextCategory, endpoint) => {
    const baseURL = 'https://terracharms.com'; // Base URL for your backend
    const url = `${baseURL}${endpoint}`;

    console.log(`URL: ${url}`);
    console.log(`Data: ${JSON.stringify(formData[category])}`);

    axios.patch(url, formData[category])
      .then(response => {
        console.log(`${category} updated successfully:`, response.data);
        if (nextCategory) {
          setActiveCategory(nextCategory);
        } else {
          navigate(`/sellerdash/${pk}`); // Navigate to seller dashboard after the last form submission
        }
      })
      .catch(error => {
        console.error(`Error updating ${category}:`, error);
      });
  };

  const renderFormInputs = (category) => {
    return Object.entries(formData[category]).map(([field, value]) => (
      <div className="input-group" key={field}>
        <label>{field}</label>
        <input
          type="text"
          value={value}
          maxLength={field === 'Pincode' ? 6 : undefined} // Set the max length to 6 for Pincode
          onChange={(e) => handleInputChange(category, field, e.target.value)}
        />
      </div>
    ));
  };

  const renderForm = () => {
    switch (activeCategory) {
      case 'GST Details':
        return (
          <div>
            <h3 className='font-bold'>GST Details Form</h3>
            {renderFormInputs('GST Details')}
            <button onClick={() => handleNextClick('GST Details', 'Pickup Details', `/seller_gst/${pk}/`)}>Next</button>
          </div>
        );
      case 'Pickup Details':
        return (
          <div>
            <h3 className='font-bold'>Pickup Details Form</h3>
            {renderFormInputs('Pickup Details')}
            <button onClick={() => handleNextClick('Pickup Details', 'Bank Details', `/seller_pickup_store/${pk}/`)}>Next</button>
          </div>
        );
      case 'Bank Details':
        return (
          <div>
            <h3 className='font-bold'>Bank Details Form</h3>
            {renderFormInputs('Bank Details')}
            <button onClick={() => handleNextClick('Bank Details', 'Supplier Address', `/seller_bank_details/${pk}/`)}>Next</button>
          </div>
        );
      case 'Supplier Address':
        return (
          <div>
            <h3 className='font-bold'>Supplier Address Form</h3>
            {renderFormInputs('Supplier Address')}
            <button onClick={() => handleNextClick('Supplier Address', '', `/seller_pickup_address/${pk}/`)}>Submit</button>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className='ml-10 bg-white mt-3 mr-10'>
      <div className="seller-form-container">
        <div className="category-container">
          <div className={`category ${activeCategory === 'GST Details' ? 'active' : ''}`} onClick={() => handleCategoryClick('GST Details')}>
            <img className="mx-auto h-10 w-auto" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcTGZumStcijds6DxW2JaWb6R7CRzO8RCzWQ&s" alt="GST Details" />
            GST Details
          </div>
          <div className={`category ${activeCategory === 'Pickup Details' ? 'active' : ''}`} onClick={() => handleCategoryClick('Pickup Details')}>
          <img className="mx-auto h-10 w-auto" src="data:image/png;base64,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" alt="Pickup Details" />
            Pickup Details
          </div>
          <div className={`category ${activeCategory === 'Bank Details' ? 'active' : ''}`} onClick={() => handleCategoryClick('Bank Details')}>
          <img className="mx-auto h-10 w-auto" src="https://cdn-icons-png.flaticon.com/512/3135/3135755.png" alt="Bank Details" />
            Bank Details
          </div>
          <div className={`category ${activeCategory === 'Supplier Address' ? 'active' : ''}`} onClick={() => handleCategoryClick('Supplier Address')}>
            <img className="mx-auto h-10 w-auto" src="https://cdn-icons-png.flaticon.com/512/684/684809.png" alt="Supplier Address" />
           
            Supplier Address
          </div>
        </div>
        <div className="form-container">
          {renderForm()}
        </div>
      </div>
    </div>
  );
}

export default SellerForm;
